/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {
  CalendarDay,
  CalendarTask,
  CalendarTaskHeaderGroup,
  CalendarTasksGroup,
  CommonUtils,
} from '@infodata-group/inf-commons';

export class CalendarResourceLine {
  public days: CalendarDay[] = [];
  public resource: CalendarTasksGroup;
  public header: CalendarTaskHeaderGroup;
  public height = 1;
  public rowHeight = 0;

  constructor(
    header: CalendarTaskHeaderGroup,
    resource: CalendarTasksGroup,
    days: Date[],
    rowHeight: number,
  ) {
    this.rowHeight = rowHeight;
    this.header = header;
    this.resource = resource;
    this.days = days.map(
      (day) =>
        new CalendarDay(
          day,
          resource.tasks.filter((t) => t.inDay(day)),
        ),
    );
    this.computeFinalHeight();
  }

  public computeFinalHeight() {
    this.days.forEach((day) => {
      if (day.rows.length > this.height) {
        this.height = day.rows.length;
      }
    });
    this.resource.increaseHeight(this.height * this.rowHeight);
  }

  getTasks(day: Date): CalendarTask[][] {
    return this.days.find((d) => CommonUtils.compareDate(d.date, day)).rows;
  }
}
